import React, { Component } from "react";
import { connect } from "react-redux";
import ForgotPasswordView from "./ForgotPasswordView";
import {
  setTranslationsAction,
  setTokenAction,
} from "../../store/Layout/actions";
import { setLoginAction, setCurrentTabAction } from "../../store/Login/actions";

class ForgotPasswordController extends Component {
  render() {
    return (
      <ForgotPasswordView
        csrf_token={this.props.csrf_token}
        isB2b={/forgot-password-b2b$/.test(
          this.props.history.location.pathname
        )}
        history={this.props.history}
        trans={this.props.trans}
        setLoginAction={this.props.setLoginAction}
        setTokenAction={this.props.setTokenAction}
        setCurrentTabAction={this.props.setCurrentTabAction}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    csrf_token: state.layout.csrf_token,
    trans: state.layout.trans,
    login: state.login.email,
    tabIndex: state.login.tabIndex,
  };
};

const mapDispatchToProps = {
  setTokenAction,
  setTranslationsAction,
  setLoginAction,
  setCurrentTabAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordController);
